<template>
  <div class="space-y-4">
    <div class="flex items-center gap-2">
      <!-- Innovadis custom image -->
      <VcImage v-if="imageSrc" :src="imageSrc" class="w-10" :alt="title" lazy />
      <h2 :class="['ml-0', { 'ml-2': imageSrc }]" class="text-xl font-extrabold">{{ title }}</h2>
    </div>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
interface IProps {
  imageSrc: string;
  title: string;
}

// Innovadis custom image src

defineProps<IProps>();
</script>
